import React, { useEffect, useState } from "react";
import { Operacao } from "../../../Models/Cadastros/Operacao/Operacao";
import DropDownListComponent from "../../../Components/Forms/DropDownListComponent";
import TextFieldComponent from "../../../Components/Forms/TextFieldComponent";
import DropDownBooleanComponent from "../../../Components/Forms/DropDownBooleanComponent";
import InlineSearchComponent from "../../../Components/Forms/InlineSearchComponent";
import ImageUploadComponent from "../../../Components/Forms/ImageUploadComponent";

const OperacaoDadosTab = (props: any) => {
    const [operacao, setOperacao] = useState<any>(new Operacao());
    const [perfis, setPerfis] = useState<any[]>([]);

    const optionAguardaSinal = [
        { label: '1', value: 1 },
        { label: '2', value: 2 },
        { label: '3', value: 3 },
        { label: '4', value: 4 },
        { label: '5', value: 5 },
        { label: '6', value: 6 },
        { label: '7', value: 7 },
        { label: '8', value: 8 },
        { label: '9', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
        { label: '18', value: 18 },
        { label: '24', value: 24 },
    ];

    const optionEmbarcaConfVeiculo = [
        { label: 'NÃO EMBARCAR', value: 1 },
        { label: 'EMBARCAR CONF. PADRÃO', value: 2 },
        { label: 'EMBARCAR CONF. POR VIAGEM', value: 3 },
    ]

    const optionEmpresaPesquisa = [
        { label: 'NENHUM', value: 1 },
        { label: 'MAXXI CADASTRO', value: 2 },
        { label: 'TELERISCO', value: 3 },
    ]

    useEffect(() => {
        setOperacao(props.operacao);
    }, [props.operacao]);
    
    return (
        <div className="row">
            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Descrição da Operação"
                    field='descricao'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Observação"
                    field='observacao'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Verifica Inicio Sem Aprovação'
                    model={operacao}
                    modelField='inicio_sem_aprovacao' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Aguarda sinal (horas)'
                    options={optionAguardaSinal}
                    valueField='value'
                    textField='label'
                    model={operacao}
                    modelField='aguarda_sinal' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Impressão de Viagem'
                    model={operacao}
                    modelField='impressao_viagem' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Embarcar configuração no veículo'
                    options={optionEmbarcaConfVeiculo}
                    valueField='value'
                    textField='label'
                    model={operacao}
                    modelField='embarcar_conf_veiculo_id' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownListComponent
                    label='Empresa de pesquisa'
                    options={optionEmpresaPesquisa}
                    valueField='value'
                    textField='label'
                    model={operacao}
                    modelField='empresa_pesquisa_id' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Aprovação Automática'
                    model={operacao}
                    modelField='aprovacao_automatica' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Quebra de Gaiola'
                    model={operacao}
                    modelField='gaiola' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Define Faixa de Horário'
                    model={operacao}
                    modelField='definefaixa' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Controle de pátio'
                    model={operacao}
                    modelField='controle_tempo_patio' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Tempo envio RATC (min)"
                    field='TempoParaRatc'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Senha WebService"
                    field='senha_ws'
                    model={operacao} />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='White list autotrac'
                    model={operacao}
                    modelField='whitelist_autotrac' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Liberar início SM'
                    model={operacao}
                    modelField='liberar_inicio_viagem' />
            </div>

            <div className="col-md-3 mb-3">
                <TextFieldComponent
                    label="Limite Máx.Garantia(LMG)"
                    field='valor_operacao'
                    model={operacao} />
            </div>

            <div className="col-md-6 mb-3">
                <InlineSearchComponent
                    label='Empresa vinculada'
                    urlApi='buscaComboEmpresas'
                    valueField='id'
                    textField='nome_completo'
                    model={operacao}
                    modelField='empresa_vinculada_id' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Empresa faturamento'
                    model={operacao}
                    modelField='empresa_faturamento_id' />
            </div>

            <div className="col-md-3 mb-3">
                <DropDownBooleanComponent
                    label='Barramento por Check-list'
                    model={operacao}
                    modelField='barramento_checklist' />
            </div>

            <div className="col-md-4 mb-2">
                    <ImageUploadComponent
                        label="Logotipo"
                        field='logotipo_checklist'
                        uploadedField='file_to_upload'
                        model={operacao}
                    />
                </div>
        </div>
    );
}

export default OperacaoDadosTab;